import { Button, Heading, Text } from "@/design-system";
import { cn } from "@/utils";
import { PageSection } from "@/pages/landingPage/components/pageSection";
import type { SeoLandingSection } from "../types";
import { SeoPicture } from "./seoPicture";

type HeroDiretoProps = Extract<SeoLandingSection, { type: "hero" }> & {
  onCtaClick: () => void;
};

export const HeroDireto = ({
  eyebrow,
  title,
  lead,
  ctaLabel,
  secondaryLabel,
  secondaryHref,
  reassurance,
  image,
  onCtaClick,
}: HeroDiretoProps) => (
  <PageSection
    labelledBy="hero-title"
    className={cn(
      "grid grid-cols-1 items-center gap-10 pt-32 md:pt-40 lg:gap-12",
      image && "lg:grid-cols-2"
    )}
  >
    <div
      className={cn("flex flex-col items-start gap-5", !image && "max-w-3xl")}
    >
      <Text size="small" tone="brand" weight="semibold">
        {eyebrow}
      </Text>
      <Heading level={1} id="hero-title" className="md:text-ds-display">
        {title}
      </Heading>
      <Text size="lead" tone="muted" className="max-w-2xl">
        {lead}
      </Text>
      <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-center">
        <Button size="lg" onClick={onCtaClick}>
          {ctaLabel}
        </Button>
        {secondaryLabel && secondaryHref ? (
          <Button asChild variant="ghost" size="lg">
            <a href={secondaryHref}>{secondaryLabel}</a>
          </Button>
        ) : null}
      </div>
      {reassurance ? (
        <Text size="small" tone="subtle">
          {reassurance}
        </Text>
      ) : null}
    </div>

    {image ? (
      <div className="rounded-ds-xl border-ds-border bg-ds-surface overflow-hidden border">
        <SeoPicture
          image={image}
          priority
          sizes="(min-width: 1024px) 560px, calc(100vw - 32px)"
        />
      </div>
    ) : null}
  </PageSection>
);
